
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gdwbnVAE1AKBzl2V6xlegVPatUlqPJ4v6_vt1pLqdU_45oMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexUyv1Pdtwm98DlH4dHB2_45gPDASY62hSzebP3ek9Z15eYMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchOTO7rw_XRVgLNM9sKan3KkF16ABBPu_MrCe64s9V6wEMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexTJ6NcCb0aTErkhbtbqyN8zYx9Y5Rlh6S8R32PYoC4D8Meta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93SDozULXKEyYZsw3raGc3gtHzDmSIG3wyWotf96it2LYMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexvAeg4KGgkDoShlXGLyPsB1ZzgWGl2ZmHOmEvjWKHdYgMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_9397q2fRrKPuSa_ikH_AKi_45tFTSEsAnZL0vMSK6xV5wLwMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexcRPEdlXAwFF5Y498yknv3YNdM1JDp_PZg77ePZ9YTg0Meta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93hnbBzoa6_45y_45lSyxHetHUiknRNxWqjr6_456D6bRWg4ZQwMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexBrlrz4o4x_45U0T_45vUfVhR5jMPLkYsjJX4oDk_45Jo1508gMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexRQaz3tEBijYF1LrVbjPdx_45aZ8TDmviNrmPEn22Y3i7YMeta } from "/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexvAeg4KGgkDoShlXGLyPsB1ZzgWGl2ZmHOmEvjWKHdYgMeta || {},
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexcRPEdlXAwFF5Y498yknv3YNdM1JDp_PZg77ePZ9YTg0Meta || {},
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexBrlrz4o4x_45U0T_45vUfVhR5jMPLkYsjJX4oDk_45Jo1508gMeta || {},
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexRQaz3tEBijYF1LrVbjPdx_45aZ8TDmviNrmPEn22Y3i7YMeta || {},
    component: () => import("/codebuild/output/src3545251159/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]